import type { CalculationType } from '@/stores/type/calculation.type'

const headers = [
  {
    title: 'Name',
    value: 'name',
    width: '200px',
    cellProps: { width: '200px' },
    headerProps: { width: '200px' }
  },
  { title: 'Ground Water Table (In Situ) [m]', value: 'ground_water_table_insitu' },
  { title: 'Ground Water Table (Design) [m]', value: 'ground_water_table_design' },
  { title: 'Earthquake Magnitude (Mw)', value: 'earthquake_magnitude' },
  { title: 'Peak Ground Acceleration (PGA) [g]', value: 'max_acceleration' },
  { title: 'Load [kN/m²]', value: 'load' },
  { title: 'Ic Limit', value: 'Ic_limit' },
  { title: 'Liquefaction Method', value: 'liquefaction_method' },
  { title: 'Liquefaction Settlement', value: 'liquefaction_settlement' },
  { title: 'Soil Classification', value: 'soil_classification' },
  { title: 'Relative Density', value: 'relative_density' },
  { title: 'Water unit weight [kN/m³]', value: 'water_unit_weight' },
  { title: 'Pre-drilling unit weight [kN/m³]', value: 'pre_drilling_weight' },
  { title: 'Atmospheric pressure [kPa]', value: 'atmospheric_pressure' }
]

export const filteredHeaders = (parameters: CalculationType, exclude: string[] = []) => {
  return headers.filter((header) => {
    if (exclude.includes(header.value)) {
      return
    }
    if (!header.filter) {
      return header
    }
    if (
      parameters[header.filter as keyof CalculationType] &&
      parameters.has_site_design_condition
    ) {
      return header
    }
  })
}
